import { render, staticRenderFns } from "./NavMark.vue?vue&type=template&id=46fe0e5b&scoped=true&"
import script from "./NavMark.vue?vue&type=script&lang=js&"
export * from "./NavMark.vue?vue&type=script&lang=js&"
import style0 from "./NavMark.vue?vue&type=style&index=0&id=46fe0e5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe0e5b",
  null
  
)

export default component.exports